import type { DesignDefinition } from '../types';

const easeOut = [0.22, 1, 0.36, 1] as const;

/** B · Nebula: calm and precise, long ease-outs and no overshoot. */
export const nebula: DesignDefinition = {
  id: 'nebula',
  name: 'Nebula',
  nameZh: '星云',
  description: 'Deep space, glass and a violet glow',
  descriptionZh: '深空、玻璃质感与紫色光晕',
  swatches: ['#7C5CFF', '#E255D0', '#5EEAD4'],
  preview: { canvas: '#0A0C1B', ink: '#E8EAFF', font: 'var(--font-sora), system-ui, sans-serif' },
  motion: {
    reveal: { transition: { duration: 0.9, ease: easeOut }, scale: 0.98 },
    heading: { duration: 1.1, ease: easeOut },
    clip: { duration: 1.1, ease: easeOut },
    stagger: 0.08,
    hover: { y: -6, rotate: 0, transition: { duration: 0.56, ease: easeOut } },
    float: { y: -10, duration: 7 },
    layout: { duration: 0.5, ease: easeOut },
  },
};
